<template>
  <div class="address-form">
    <!-- <Header :title="title" /> -->
    <form action="" class="form" @submit.prevent>
      <div class="input-item" label="收货人姓名">
        <input
          type="text"
          placeholder="请输入收货人姓名"
          v-model="form.name"
          @input="form.name = form.name.trim()"
        />
      </div>
      <div class="input-item" label="联系电话">
        <input
          type="tel"
          placeholder="请输入收货人联系电话"
          v-model="form.mobile"
          maxlength="11"
          inputmode="tel"
          @input="form.mobile = form.mobile.replace(/\D+/g, '')"
        />
      </div>
      <div class="input-item" label="收货地区">
        <input
          type="text"
          placeholder="请选择收货地区"
          :value="area"
          readonly
          @click="show = true"
        />
      </div>
      <div class="input-item" label="详细地址">
        <input
          type="text"
          placeholder="请输入详细地址如楼号/单元号/房间号"
          v-model="form.address"
          @blur="form.address = form.address.replace(/(\s)\s+/g, '$1').trim()"
        />
      </div>
      <button class="btnCom" @click="submit">确定</button>
    </form>
    <van-popup v-model="show" position="bottom">
      <van-area
        :area-list="areaList"
        :value="areaValue"
        @cancel="cancel"
        @confirm="confirm"
      />
    </van-popup>
  </div>
</template>

<script type="text/ecmascript-6">
import areaList from "./../../../assets/js/area.js";

export default {
  data() {
    return {
      title: "",
      form: {
        name: "", // 必选 收件人姓名
        mobile: "", // 必选 收件人手机号
        province: "", // 必选 省份行政编码
        city: "", // 必选 城市行政编码
        county: "", // 必选 县区行政编码
        address: "", // 必选 详细地址
      },
      areaList: areaList,
      areaValue: "",
      show: false,
      area: "",
      keyMap: ["province", "city", "county"],
    };
  },
  methods: {
    submit() {
      this.$post({
        module: "Address",
        interface: this.form.id ? "2003" : "2001",
        data: this.form,
      }).then((res) => {
        this.$toast(res.message || "成功");
        this.$func.sleep().then(() => {
          this.$router.back();
        });
      });
    },
    cancel() {
      this.show = false;
    },
    confirm(params) {
      let area = "";
      params.forEach((item, index) => {
        let name, code;
        if (item) {
          name = item.name;
          code = item.code;
          this.areaValue = code;
        } else {
          name = "";
          code = "";
        }
        area += area ? " " + name : name;
        let key = this.keyMap[index];
        this.form[key] = code;
      });
      this.area = area;
      this.show = false;
    },
    getInfo() {
      this.$post({
        module: "Address",
        interface: "2002",
        data: {
          id: this.form.id,
        },
      }).then((res) => {
        // console.log("地址", res);
        this.form.province = res.province;
        this.form.city = res.city;
        this.form.county = res.county;
        this.form.name = res.name;
        this.form.address = res.address;
        this.form.mobile = res.mobile;
        this.area =
          res.provinceName + " " + res.cityName + " " + res.countyName;
        this.areaValue = res.county;
      });
    },
  },
  computed: {},
  components: {},
  created() {
    this.form.id = this.$route.query.id;
    if (this.form.id) {
      this.getInfo();
    }
    this.title = this.$route.query.id ? "修改地址" : "添加地址";
  },
};
</script>

<style scoped lang="less">
.form {
  padding: 14px 16px;

  .input-item {
    background: #ffffff;
    box-shadow: 0px 0px 16px 0px rgba(96, 98, 102, 0.08);
    border-radius: 8px;
    margin-bottom: 11px;
    padding: 18px 14px 16px;

    &::before {
      content: attr(label);
      font-size: 13px;
      color: #303133;
    }

    input {
      display: block;
      margin-top: 17px;
      font-size: 14px;
      color: #101010;

      &::placeholder {
        color: #919398;
      }
    }
  }

  .btnCom {
    border-style: none;
    margin-top: 60px;
    font-size: 18px;
  }
}
/deep/.van-picker__confirm {
  color: #158dff;
}
</style>